import { ReactNode, useState, ToggleEvent } from "react";
import { icons } from "../../Helpers/WindowHelpers"
import { sectionSettings } from "../../Helpers/WindowHelpers";
import parse from 'html-react-parser';

interface HeaderStepDesktopInterface {
    title: string,
    stepNumber: number,
    stepValue: number,
    setStep: (step: number) => void,
    children?: ReactNode,
    classes?: string
}

declare global {
    interface DetailsHTMLAttributes<HTMLDetailsElement> {
        disabled: boolean;
    }
}

const HeaderStepDesktop = ({ title, stepNumber, stepValue, setStep, children, classes }: HeaderStepDesktopInterface) => {
    const active = stepNumber == (stepValue - 2) ? 'is-active' : '';
    const complete = stepNumber > (stepValue - 2) ? 'is-complete' : '';

    const editSelected = () => {
        setStep(stepValue - 2);
        document.querySelectorAll('details[name=configurator-summary]').forEach((details: HTMLDetailsElement) => details.open = false);
    }

    return (
        <div className={`configurator-steps__step d--flex align-items--start is-step-${stepValue} ${active} ${complete} ${classes || ''}`}>
            {/* @ts-ignore */}
            <span className={`configurator-steps__count flex-center ${active} ${complete}`}>
                {stepValue < 10 ? '0':''}{stepValue}
            </span>
            <details className={`configurator-steps__toggle flex-grow sm--disabled ${active}`} name="configurator-summary" tabIndex={(active || complete) ? 0 : -1} aria-disabled={!(active || complete)}>
                <summary role="button" className="configurator-steps__step--inner">
                    <span className="configurator-steps__title">
                        <span>{title}</span>
                        {active || complete ? <span className="lg-down--hide">{parse(icons.caretDown ?? '')}</span> : null}
                    </span>
                </summary>
                <div className="configurator-steps__dropdown">
                    {children}
                </div>
            </details>
            <button className="configurator-steps__edit link lg-down--hide" type="button" onClick={() => editSelected()}>{sectionSettings.label_edit}</button>
        </div>
    )
}

export default HeaderStepDesktop;